var map = {
	"./icon-payment-card-american-express.svg": 1742,
	"./icon-payment-card-discover.svg": 2089,
	"./icon-payment-card-mastercard.svg": 1743,
	"./icon-payment-card-paypal.svg": 1773,
	"./icon-payment-card-visa.svg": 1774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2088;